import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-p2-webpage-table',
    templateUrl: './p2-webpage-table.component.html',
    styleUrls: ['./p2-webpage-table.component.css'],
    standalone: false,
})
export class P2WebpageTableComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetP2WebpageTablesParams;

    public grid?: GridOptions;

    constructor(@Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public loadPage(): void {
        if (!this.params) return;

        const method = this.params.argtype === '-' ? 4058 : 4057;
        if (!this.grid || this.grid.dataTask?.loadData?.method !== method) {
            this.grid = new Grid()
                .setRememberId(method === 4058 ? 'w_p2webpagetable_navigation_grid' : 'w_p2webpagetable_grid')
                .setLoadDataFunction({ method, parameters: () => this.params })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setHeading?.('h_p2_webpage_table', true);
            this.params = this.navigator.params as any;
            this.loadPage();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.loadPage();
        }
    }
}

export interface GetP2WebpageTablesParams {
    argtype: string;
    argvalue: string;
}
